import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';

interface HeaderModalPayProps {
  onClose: () => void;
}

export const HeaderModalPay: React.FC<HeaderModalPayProps> = ({ onClose }) => {
  return (
    <>
      <Box
        marginBottom={2}
        display={'flex'}
        flexDirection={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Box display="block">
          <Typography variant={'h6'} fontWeight={'bold'}>
            ¿Cómo quieres pagar?
          </Typography>
        </Box>
        <IconButton onClick={onClose}>
          <ClearIcon />
        </IconButton>
      </Box>
    </>
  );
};
